// Actions
export const COMPLETE_SAVE = 'customers/services/COMPLETE_SAVE';
export const COMPLETE_DELETE = 'customers/services/COMPLETE_DELETE';
